/*
Arquivo destinado a melhorias de usabilidade.
*/
AGA.UxImprovements = (function () {

    var showErrorCount = function () {
        try {
            var tabs = $('[data-toggle=tab]');
            tabs.each(function () {
                var href = $(this).attr('href');
                if (href && href.startsWith('#')) {
                    var errors = $(href).find(".has-error").length;
                    $(this).find('.badge-error-count').remove();
                    if (errors > 0) {
                        $(this).append('<span class="badge badge-danger badge-error-count">' + errors + '</span>');
                        $(this).addClass('badge-error-tab');
                    } else {
                        $(this).removeClass('.badge-error-tab');
                    }
                }
            });

        } catch (error) {
            // Os erros que acontecerem aqui não devem parar o processo.
            console.error(error);
        }
    }

    var initImplementation = function () {
        if (window.Sys !== undefined) {
            var prm = Sys.WebForms.PageRequestManager.getInstance();
            prm.add_endRequest(showErrorCount);
        }
    };

    return {
        init: initImplementation
    };

})();

$(document).ready(function () {
    AGA.UxImprovements.init();
});